export const DEBUG_CONFIG = {
    FILL_COLOR: 0x00ff00,
    FILL_ALPHA: 0.3,
    LINE_COLOR: 0x00ff00,
    LINE_WIDTH: 2
};

export const SHARED_DEFAULT_STYLE_NAME = 'default';
